module.exports = __webpack_public_path__ + "static/media/delivery_rescheduled.e2ce5969.png";